import InfoPersoStep4FormComponent from '../../components/info-perso/InfoPersoStep4FormComponent';


export default function InfoPersoStep4Bloc() {

      return (
        <div className="">
          <div className="">
            {/* <h2 className="card-title bleu">Accélérez vos remboursements : </h2> */}
            <p className="text mt-sm"></p>
            
            <InfoPersoStep4FormComponent/>  
          </div>
          
        </div>
      )
}